/* eslint-disable default-case */
/* eslint-disable consistent-return */

import vfgHelpers from '@/mixins/helpers/vfg-helpers';
import ormHelpers from '@/mixins/admin/helpers/orm-helpers';

import { mapState } from 'vuex';

export default {

  mixins: [
    vfgHelpers, //
    ormHelpers,
  ],

  data() {
    return {
      form: {
        schema: {
          fields: [],
        },
        model: {},
        options: {},
      },
    };
  },

  computed: {
    ...mapState({
      fetcherAdminSchemas: state => state.fetcherAdminSchemas.fetcherAdminSchemas,
      spawnerAdminSchemas: state => state.spawnerAdminSchemas.spawnerAdminSchemas,
      // crawlerAdminSchemas: state => state.crawlerAdminSchemas.crawlerAdminSchemas,
      // monitorAdminSchemas: state => state.monitorAdminSchemas.monitorAdminSchemas,
    }),
  },

  methods: {
    onReset() {
      console.log('resetting form');
      this.errors = {};
    },

    clear(data) {
      this[data] = {
        id: null,
        name: null,
      };
    },

    generateSchema(module, model, mode) {
      this.form.schema = { fields: [] };
      this.form.model = {};

      const schemas = this[`${module}AdminSchemas`];

      // console.log(module, schemas);

      if (Object.keys(schemas.forms[model].fields[mode]).length === 0) {
        console.log(`${model} schema is empty!`, schemas.forms[model].fields[mode]);
        return;
      }

      Object.keys(schemas.forms[model].fields[mode]).forEach((key) => {
        const name = key;
        let type = schemas.forms[model].fields[mode][key].split('|')[0];

        let properties = JSON.parse(schemas.forms[model].fields[mode][key].split('|')[1] || null);

        // console.log('key', key);
        // console.log('name', name);
        // console.log('properties', properties);

        if (type === 'DateTime') {
          type = 'Input';
        } else if (type === 'Json') {
          type = 'TextArea';
        }

        if (properties == null) {
          properties = {};
        }

        properties.label = name;
        properties.model = name.toLowerCase();

        const element = Object.values(this.vfgFields).filter((el) => el.name === type)[0];

        if (!element) {
          console.log(`unknown field type ${type}`);
        }

        if (element.name === 'Select' && properties['select-model']) {
          const selectModel = properties['select-model'];
          delete properties['select-model'];

          console.log('select-model', selectModel);

          const orm = this.getOrmEntity(selectModel);

          properties.values = [];
          const records = orm.query()
            .orderBy('id')
            .get();

          Object.keys(records).forEach((k) => {
            properties.values.push({
              id: records[k].id,
              name: records[k].name,
            });
          });

          // console.log('values', properties.values);
        }

        if (properties.default) {
          this.form.model[properties.model] = properties.default;
          delete properties.default;
        } else {
          this.form.model[properties.model] = null;
        }

        this.insertElement(element, properties);
      });
    },

    loadModel(model) {
      this.form.model = model;

      Object.keys(this.form.model).forEach((k) => {
        // console.log(typeof this.form.model[k]);
        if (typeof this.form.model[k] === 'object' && this.form.model[k] !== null) {
          // console.log(this.form.model[k]);
          this.form.model[k] = JSON.stringify(this.form.model[k]);
        }
      });
    },

    insertOrUpdate() {
      this.$store.state.loading = true;
      this.errors = {};
      this.$http({
        method: this.mode === 'add' ? 'post' : 'patch',
        url: this.api[this.mode],
        data: this.form.model,
      })
        .then((response) => {
          console.log('success', response.data);
        })
        .catch((response) => {
          // console.log('error.response', response);
          // console.log('error.response.message', response.message);
          // console.log('error.response.response.data', response.response.data);
          // console.log('error.response.response.errors', response.response.data.errors);
          this.errors = response.response.data.errors;
        });

      this.$store.state.loading = false;
    },

  },

  mounted() {
    Bus.$on('update_form', (form, data, formField, item) => {
      // console.log(`update_form ${form}, ${data}, ${formField}, ${item}`);
      this.form[formField] = item.id;
      this[data] = {
        id: item.id,
        name: item.name,
      };
    });

    // this.initForm();
  },

  beforeDestroy() {
    Bus.$off('update_form');
  },
};
